const properties = {
    BUILD_TYPE: "development",
    DOMAIN_URL: "amigogroup.id"
};

export default properties;
